import { CheckCircleFilled, ErrorCircleFilled } from '@ori-ui/icons';
import { styled } from '@ori-ui/mui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PasswordRequirementsRoot = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    position: 'relative',
    marginBottom: theme.spacing(4)
  };
});
var PasswordRequirementRoot = styled('div')(function () {
  return {
    position: 'relative'
  };
});
var RequirementIconWrapper = styled('span')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    position: 'relative',
    marginRight: theme.spacing(2)
  };
});
var RequirementText = styled('span')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    fontSize: '12px',
    color: theme.palette.default.main,
    position: 'relative',
    top: '-8px'
  };
});
export var FulfilledIcon = styled(CheckCircleFilled)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.palette.primary.main
  };
});
export var UnfulfilledIcon = styled(ErrorCircleFilled)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    color: theme.palette.error.dark
  };
});
export var UnknownIcon = styled(CheckCircleFilled)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    color: theme.palette.grey.A400
  };
});
var RequirementState;

(function (RequirementState) {
  RequirementState[RequirementState["Unknown"] = 0] = "Unknown";
  RequirementState[RequirementState["Fulfilled"] = 1] = "Fulfilled";
  RequirementState[RequirementState["Unfulfilled"] = 2] = "Unfulfilled";
})(RequirementState || (RequirementState = {}));

var PasswordRequirementElement = function PasswordRequirementElement(props) {
  var icon;
  var state = props.state,
      label = props.label;

  switch (state) {
    case RequirementState.Fulfilled:
      {
        icon = /*#__PURE__*/_jsx(FulfilledIcon, {});
        break;
      }

    case RequirementState.Unfulfilled:
      {
        icon = /*#__PURE__*/_jsx(UnfulfilledIcon, {});
        break;
      }

    default:
      {
        icon = /*#__PURE__*/_jsx(UnknownIcon, {});
        break;
      }
  }

  return /*#__PURE__*/_jsxs(PasswordRequirementRoot, {
    children: [/*#__PURE__*/_jsx(RequirementIconWrapper, {
      children: icon
    }), /*#__PURE__*/_jsx(RequirementText, {
      children: label
    })]
  });
};

var getState = function getState(isInitialState, unfulfilledRequirementKeys, requirementKey) {
  if (isInitialState) {
    return RequirementState.Unknown;
  }

  return unfulfilledRequirementKeys !== null && unfulfilledRequirementKeys !== void 0 && unfulfilledRequirementKeys.includes(requirementKey) ? RequirementState.Unfulfilled : RequirementState.Fulfilled;
};

export var PasswordRequirements = function PasswordRequirements(props) {
  var requirements = props.requirements,
      unfulfilledRequirementKeys = props.unfulfilledRequirementKeys,
      isInUnknownState = props.isInUnknownState;
  return /*#__PURE__*/_jsx(PasswordRequirementsRoot, {
    children: requirements.map(function (element) {
      return /*#__PURE__*/_jsx(PasswordRequirementElement, {
        label: element.localizedText,
        state: getState(isInUnknownState, unfulfilledRequirementKeys, element.key)
      }, element.key);
    })
  });
};